import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdateNotificationEmailPayload = {
  notification_email: string;
  checkin_service_id: number;
  dealer_location_id: number;
};

export const useUpdateNotificationEmailMutation = () =>
  useTypedMutation<UpdateNotificationEmailPayload, void>({
    mutationFn: payload => ApiInstance.post("/check_in/service/update_notification_email", payload),
    onSuccess: payload => {
      const locationServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.locationList);
      if (!locationServices) return;

      const serviceIdx = locationServices.findIndex(service => service.id === payload.checkin_service_id);
      if (serviceIdx === -1) return;

      typedQueryClient.setQueryData(
        CheckInServicesQueryKeys.locationList,
        locationServices.with(serviceIdx, { ...locationServices[serviceIdx], notification_email: payload.notification_email })
      );
    }
  });
